<template lang="pug">
section
  header.header-settings
    .tabs
      .tab.primary-text.active
        span Intercom

  has-access(allowance="integration.intercom")
    AlertBox(v-if="alert", :type="alert.type", :text="alert.text")

    section.sub-section(v-if="!configuration.vendor_data")
      p Enable Intercom and allow a tool your users are already familiar with to solicite feedback!
      a(
        href="https://app.intercom.io/oauth?client_id=01a00494-2af2-4d02-9518-191db912a2d8&state=example"
      )
        img(
          src="https://static.intercomassets.com/assets/oauth/primary-7edb2ebce84c088063f4b86049747c3a.png",
          srcset="https://static.intercomassets.com/assets/oauth/primary-7edb2ebce84c088063f4b86049747c3a.png 1x, https://static.intercomassets.com/assets/oauth/primary@2x-0d69ca2141dfdfa0535634610be80994.png 2x, https://static.intercomassets.com/assets/oauth/primary@3x-788ed3c44d63a6aec3927285e920f542.png 3x"
        )

    div(v-if="configuration.vendor_data")
      .info-field
        h6 Intercom Workspace
        p {{ configuration.vendor_data.app.name }}

      .info-field
        h6 Added by
        p {{ configuration.vendor_data.name }} ({{ configuration.vendor_data.email }})

      form(@keyup.enter="submit", @submit.prevent="submit")
        .form-field-group.no-padding
          h6 Configurations
          .form-field
            label
              .form-field-select
                SelectInput(
                  header="Default Board",
                  :options="boards",
                  :empty="{ name: 'Select One', _id: null }",
                  label="name",
                  v-model="configuration.defaultBoard"
                )

        .form-field
          SubmitButton(label="Save", :formState="formState")

      section.sub-section
        p To remove this integration, you must uninstall from Intercom
</template>

<script>

import { mapState } from 'vuex'
import SelectInput from '@/components/helpers/SelectInput'

export default {
  name: 'SettingsIntercom',
  components: {
    SelectInput
  },
  beforeCreate () {
    this.$store.dispatch('integrations/getIntegration', 'intercom')
      .then((integration) => {
        if(integration.configuration)
          this.configuration = integration.configuration
          console.log(integration)
      })
  },
  mounted () {
  },
  data () {
    return {
      alert: null,
      configuration: {
        defaultBoard: null
      },
      formState: 'initial'
    }
  },
  computed: {
     ...mapState({
      boards: state => state.boards.list
    })
  },
  methods: {
    submit () {
      this.formState = 'pending'
      this.$store
        .dispatch('integrations/putIntegrationConfiguration', {
          type: 'intercom',
          configuration: this.configuration
        })
        .then(
          (integration) => {
            this.configuration = integration.configuration
            this.formState = 'success'
          },
          (errors) => {
            this.errors = errors
            console.log(errors)
          }
        )
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
